'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _UIButton = require('./UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UILoadingSpinner = require('../loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _Functions = require('../core/Functions');

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClassName = function getClassName(className, use, displayResult, isLoading) {
  return (0, _classNames2.default)('private-loading-button', className, _ButtonConstants.USE_CLASSES[use], {
    'loading private-loading-button--loading': isLoading || displayResult
  });
};

exports.default = _react2.default.createClass({
  displayName: 'UILoadingButton',

  propTypes: _extends({}, _UIButton2.default.propTypes, {
    failed: _UILoadingSpinner2.default.propTypes.failed,
    size: _UILoadingSpinner2.default.propTypes.size,
    use: _UILoadingSpinner2.default.propTypes.use,
    duration: _react.PropTypes.number,
    loading: _react.PropTypes.bool,
    resultIcon: _UILoadingSpinner2.default.propTypes.resultIcon,
    onLoadingFinish: _react.PropTypes.func,
    spinnerProps: _react.PropTypes.object,
    preventClicksOnLoading: _react.PropTypes.bool,
    keepResultAfterFinish: _react.PropTypes.bool
  }),

  getDefaultProps: function getDefaultProps() {
    var _UILoadingSpinner$def = _UILoadingSpinner2.default.defaultProps,
        failed = _UILoadingSpinner$def.failed,
        resultIcon = _UILoadingSpinner$def.resultIcon;


    return _extends({}, _UIButton2.default.defaultProps, {
      failed: failed,
      onLoadingFinish: _emptyFunction2.default,
      preventClicksOnLoading: true,
      keepResultAfterFinish: false,
      resultIcon: resultIcon,
      size: 'medium',
      use: 'secondary'
    });
  },
  getInitialState: function getInitialState() {
    var loading = this.props.loading;


    return {
      displayResult: false,
      isLoading: loading || false
    };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        loading = _props.loading,
        duration = _props.duration;

    (0, _invariant2.default)(typeof loading !== 'undefined' || duration, 'You must supply either a duration or loading prop to `LoadingButton`');
  },
  componentDidMount: function componentDidMount() {
    var duration = this.props.duration;
    var isLoading = this.state.isLoading;

    if (duration && isLoading) {
      this.loadingTimeout = setTimeout(this.handleLoadingFinish, duration);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var wasLoading = this.props.loading;
    var failed = nextProps.failed,
        loading = nextProps.loading,
        resultIcon = nextProps.resultIcon;


    var hasResult = resultIcon && !failed;
    var shouldDisplayResult = hasResult && wasLoading && !loading;

    if (loading !== wasLoading) {
      this.setState({
        isLoading: loading,
        displayResult: shouldDisplayResult
      });
    }
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    var duration = nextProps.duration;
    var wasLoading = this.state.isLoading;
    var isLoading = nextState.isLoading;


    var startedLoading = !wasLoading && isLoading;

    if (duration && startedLoading) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(this.handleLoadingFinish, duration);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.loadingTimeout);
  },
  handleLoadingFinish: function handleLoadingFinish() {
    var _props2 = this.props,
        failed = _props2.failed,
        resultIcon = _props2.resultIcon;


    var hasResult = resultIcon && !failed;
    this.setState({
      isLoading: false,
      displayResult: hasResult
    });

    if (!hasResult) {
      this.setDisplayResult();
    }
  },
  setDisplayResult: function setDisplayResult() {
    var _props3 = this.props,
        onLoadingFinish = _props3.onLoadingFinish,
        keepResultAfterFinish = _props3.keepResultAfterFinish;

    this.setState({
      displayResult: keepResultAfterFinish
    });
    onLoadingFinish();
  },
  handleClick: function handleClick(evt) {
    var _props4 = this.props,
        duration = _props4.duration,
        onClick = _props4.onClick,
        preventClicksOnLoading = _props4.preventClicksOnLoading;
    var _state = this.state,
        displayResult = _state.displayResult,
        isLoading = _state.isLoading;


    if (preventClicksOnLoading && (isLoading || displayResult)) {
      return;
    }

    (0, _Functions.callIfPossible)(onClick, evt);
    if (evt.defaultPrevented) {
      return;
    }

    if (!isLoading && duration) {
      this.setState({
        isLoading: true
      });
    }
  },
  render: function render() {
    var _props5 = this.props,
        children = _props5.children,
        className = _props5.className,
        disabled = _props5.disabled,
        __duration = _props5.duration,
        failed = _props5.failed,
        __loading = _props5.loading,
        __onClick = _props5.onClick,
        __onLoadingFinish = _props5.onLoadingFinish,
        __preventClicksOnLoading = _props5.preventClicksOnLoading,
        __keepResultAfterFinish = _props5.keepResultAfterFinish,
        resultIcon = _props5.resultIcon,
        size = _props5.size,
        spinnerProps = _props5.spinnerProps,
        use = _props5.use,
        rest = _objectWithoutProperties(_props5, ['children', 'className', 'disabled', 'duration', 'failed', 'loading', 'onClick', 'onLoadingFinish', 'preventClicksOnLoading', 'keepResultAfterFinish', 'resultIcon', 'size', 'spinnerProps', 'use']);

    var _state2 = this.state,
        isLoading = _state2.isLoading,
        displayResult = _state2.displayResult;

    var disabledUnlessLoading = disabled && !isLoading && !displayResult;

    return _react2.default.createElement(
      _UIButton2.default,
      _extends({}, rest, {
        size: size,
        use: use,
        'data-loading': isLoading,
        disabled: disabledUnlessLoading,
        className: getClassName(className, use, displayResult, isLoading),
        onClick: this.handleClick
      }),
      _react2.default.createElement(
        'div',
        { className: 'private-loading-button__content' },
        children
      ),
      _react2.default.createElement(_UILoadingSpinner2.default, _extends({}, spinnerProps, {
        className: 'private-loading-button__spinner',
        'data-loading': null,
        failed: failed,
        use: use,
        size: size,
        resultIcon: resultIcon,
        showResult: displayResult,
        onResultDisplayFinish: this.setDisplayResult
      }))
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/button/UILoadingButton.js
// module id = 349
// module chunks = 3 4 5